import { getFormPropz } from '../../components/forms/props/formPropz';
import { gEnums } from '../../enums/globalEnums';
import { grts, responseReducers } from './reducerHelpers/dispatchProps';
import _ from 'lodash'

const rts = {
  handleInit_formProps: 'handleInit_formProps',
  handleInit_form: 'handleInit_form',
  handleLocalPropChange: 'handleLocalPropChange',
  ...grts
}

export const appFormReducer = (state, action) => {

  const { type, dispatch } = action
  const { formProps } = state

  const { handleLocalPropChange } = appFormHandlers(dispatch)
  const form_handlers = { handleFormDataChange_local: handleLocalPropChange }

  switch (type) {

    // case rts.handleAppForms:
    //   if (action.appForms && action.appForms.appForms) {
    //     return { ...state, currentAppForms: action.appForms.appForms }
    //   } else {
    //     return { ...state, currentAppForms: action.appForms }
    //   }

    case rts.handleInit_formProps:
      return { ...state, ...action.formPropz }

    case rts.handleInit_form:
      const data = getFormInit(state, action, form_handlers)
      if (action.defaultOptions) {
        Object.keys(action.defaultOptions).forEach(dpk => {
          if (data.viewProps && data.viewProps[dpk]) {
            data.viewProps[dpk].data.trueList = action.defaultOptions[dpk]
          }
        })
      }
      // console.group('handleInit_form')
      // console.log('formPropz', action.formPropz)
      // console.log('data', data)
      // console.groupEnd()
      return { ...state, ...data }

    case rts.handleLocalPropChange:
      return { ...state, data_form: action.data_form }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const appFormInitialState = (initState) => {
  return { ...initState }
};

export const appFormHandlers = (dispatch) => {
  return {
    handleInit_formProps: (formPropz) => { dispatch({ type: rts.handleInit_formProps, dispatch, formPropz }) },
    handleInit_form: (init_state, formPropz) => { dispatch({ type: rts.handleInit_form, dispatch, init_state, formPropz }) },
    handleLocalPropChange: (data_form) => { dispatch({ type: rts.handleLocalPropChange, dispatch, data_form }) },
  }
}

const getFormInit = (state, action, form_handlers) => {

  const { appForms, appFormType, appFormTypes, appFormItems, propIgnores, vit, data_parent: data_parent_s } = state ?? {}
  const { init_state } = action ?? {}
  const { data_parent: data_parent_a, appFormType: appFormType_action } = init_state ?? {}

  const _appFormType = appFormType_action ? appFormType_action : appFormType

  const _data_parent = data_parent_a ? data_parent_a : data_parent_s

  const data = {
    formProps: null,
    viewProps: null,
    noProps: false,
    data_form: _data_parent
  }

  if (appForms) {
    if (appFormTypes) {
      let allViewProps = {}
      appFormTypes.forEach(aft => {
        if (appForms[aft]) {
          const _viewProps = appForms[aft]
          allViewProps = { ...allViewProps, ..._viewProps }
        }
      })
      if (allViewProps && propIgnores) propIgnores.forEach(pi => { delete allViewProps[pi] })
      const fpp = { form_handlers, updateProps: { vit }, viewProps: allViewProps, data_init: _data_parent }
      const _formProps = getFormPropz(fpp)
      data.data_parent = _data_parent
      data.formProps = _formProps
      data.viewProps = allViewProps
    } else if (_appFormType && appForms[_appFormType]) {
      const _viewProps = appForms[_appFormType]
      if (_viewProps && propIgnores) propIgnores.forEach(pi => { delete _viewProps[pi] })
      const fpp = { form_handlers, updateProps: { vit }, viewProps: _viewProps, data_init: _data_parent }
      const _formProps = getFormPropz(fpp)
      data.data_parent = _data_parent
      data.formProps = _formProps
      data.viewProps = _viewProps
    } else if (appFormItems) {
      const fpp = { form_handlers, updateProps: { vit }, viewProps: appFormItems, data_init: _data_parent }
      const _formProps = getFormPropz(fpp)
      data.data_parent = _data_parent
      data.formProps = _formProps
      data.viewProps = appFormItems
    } else {
      data.noProps = true
    }
  }

  return data
}